import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from "react-loader";
import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import {
  FormLabel,
  LargeButton,
  GalleryButton,
  Wrapper,
  Content,
  ContentCol,
  ContentRow,
  ContentRowSingleCol,
  InputWrapper,
} from "./AssetCollection.styles";
import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import { PROXIED_MEDIABASE } from "../../../../common/constants";
import withServices from "../../../../HOCs/withServices";

import Vimeo from "@u-wave/react-vimeo";
import { Player, BigPlayButton } from "video-react";

import { Scrollbars } from "react-custom-scrollbars";

interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  data: any;
  selectedLesson: string;
  isNavigate: boolean;
  destination: string;
}

class AssetCollection extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      destination: "",
      toLogin: false,
      loaded: true,
      isNavigate: false,
      data: {},
      selectedLesson: "",
    };

    this.onLogout = this.onLogout.bind(this);
    this.onGoBack = this.onGoBack.bind(this);
    this.uploadSubmit = this.uploadSubmit.bind(this);
    this.uploadToggle = this.uploadToggle.bind(this);
    this.updateInfo = this.updateInfo.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.imageToggle = this.imageToggle.bind(this);
    this.imageClick = this.imageClick.bind(this);
    this.imageUpdateInfo = this.imageUpdateInfo.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.imageDelete = this.imageDelete.bind(this);
    this.onSlide = this.onSlide.bind(this);
    this._renderCustomControls = this._renderCustomControls.bind(this);
    this.vimeoToggle = this.vimeoToggle.bind(this);
    this.saveVimeo = this.saveVimeo.bind(this);
    this.vimeoVideoClick = this.vimeoVideoClick.bind(this);
    this.loadAssets = this.loadAssets.bind(this);
  }

  public onGoBack() {
    const { history } = this.props;

    const dest = this.props.services.currentBaseUrl + "asset_collections";

    console.log(dest);

    this.setState({
      isNavigate: true,
      destination: dest,
    });
  }

  public setTab(param, e) {
    const data = this.state.data;
    data.activetab = param;
    this.setState({
      data,
    });
  }

  public imageToggle(data, e) {
    data.imagemodal = !data.imagemodal;

    console.log(data.imagemodal);

    this.setState({ data });
  }

  public uploadToggle() {
    const data = this.state.data;
    data.uploadModal = !data.uploadModal;

    console.log(data.uploadModal);

    this.setState({ data });
  }

  public vimeoToggle() {
    const data = this.state.data;
    data.vimeoModal = !data.vimeoModal;

    console.log(data.vimeoModal);

    this.setState({ data });
  }

  public async saveVimeo(vid) {
    const item = {
      video: vid,
      collection: this.state.data.assetCollectionID,
    };

    const res = await this.props.services.adminAPI.saveVimeo(item);

    if (res.ok) {
      toast.success("Successful addition");
    } else {
      toast.error("Failed");
    }
  }

  public async uploadSubmit(e) {
    e.preventDefault();

    const data = this.state.data;

    data.uploading = true;

    this.setState({ data }); 

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    formData.append("asset_collection_id", data.assetCollectionID);
    formData.append("description", e.target.elements.description.value);

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }
    console.log('FOrmData: ' + formData, null, 2);
    const res = await this.props.services.adminAPI.updloadAsset(formData);

    if (res.ok) {
      const data = this.state.data;

      data.uploading = false;

      data.uploadModal = false;

      this.setState({ data });

      toast.success("Success, asset is being optimized, may take a minute");

      setTimeout(this.loadAssets, 12000);
    } else {
      toast.error("Failed to complete upload");
    }

    data.uploading = false;

    this.setState({ data });
  }

  public imageModal(data) {
    return (
      // tslint:disable-next-line jsx-no-lambda
      <Modal
        isOpen={data.imagemodal}
        toggle={this.imageToggle.bind(this, data)}
        className=""
      >
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <ModalHeader toggle={(e) => this.imageToggle(data, e)}>
          Preview
        </ModalHeader>
        <ModalBody>
          <Content>
            <ContentCol>
              <FormLabel htmlFor="title" style={{ display: "block" }}>
                Title
              </FormLabel>
              {/*tslint:disable-next-line jsx-no-lambda*/}
              <textarea
                rows={3}
                cols={10}
                id="title"
                value={data.selectedImage.Title}
                onChange={this.handleImageChange.bind(this, "Title")}
              />
              <br />
              <br />
            </ContentCol>

            <ContentCol>
              <FormLabel htmlFor="description" style={{ display: "block" }}>
                Description
              </FormLabel>
              {/*tslint:disable-next-line jsx-no-lambda*/}
              <textarea
                rows={3}
                cols={10}
                id="description"
                value={data.selectedImage.Description}
                onChange={this.handleImageChange.bind(this,"Description")}
              />
              <br />
              <br />
            </ContentCol>

            <ContentCol>
              <LargeButton onClick={this.imageUpdateInfo}>Submit</LargeButton>
            </ContentCol>

            <ContentCol>
              {/*tslint:disable-next-line jsx-no-lambda*/}
              <LargeButton
                onClick={this.imageDelete.bind(this, data.selectedImage)}
              >
                Delete
              </LargeButton>
            </ContentCol>
          </Content>
        </ModalBody>
      </Modal>
    );
  }

  public onLogout() {
    this.setState({ toLogin: true });
  }

  public async loadAssets() {
    const assetCollectionID = this.state.data.assetCollectionID;

    const [assetsRes, vimeoRes, videoRes, vimeoAssetRes] = await Promise.all([
      this.props.services.adminAPI.getCollectionItems(assetCollectionID),
      this.props.services.adminAPI.getVimeoVideos(),
      this.props.services.adminAPI.getCollectionVideoItems(assetCollectionID),
      this.props.services.adminAPI.getCollectionVimeoItems(assetCollectionID),
    ]);

    const data = this.state.data;

    data.assets = assetsRes.data.assets;

    data.videoAssets = videoRes.data.assets;

    data.vimeoAssets = vimeoAssetRes.data.assets;

    this.setState({
      data,
      loaded: true,
    });
  }

  public async imageDelete(curritem) {
    const retVal = confirm("Do you want to continue ?");
    if (!retVal) {
      return;
    }

    this.setState({
      loaded: false,
    });

    const item = curritem;
    console.log('ItemTODelete: ' + JSON.stringify(item))

    const res = await this.props.services.adminAPI.deleteItemGeneral(
      "assets",
      item.id
    );

    if (res.ok) {
      this.loadAssets();

      const data = this.state.data;

      data.imagemodal = !data.imagemodal;

      console.log(data.imagemodal);

      this.setState({
        data,
        loaded: true,
      });

      // const assetsRes = await this.props.services.adminAPI.getCollectionItems(assetCollectionID);
    } else {
      toast.error("Error deleting item!");
    }
  }

  public processImages(assets) {
    const images = [] as any[];

    for (const asset of assets) {
      console.log(asset);
      images.push({
        original: PROXIED_MEDIABASE + "assets/" + asset.FileName,
        thumbnail: PROXIED_MEDIABASE + "assets/" + asset.FileName,
      });
    }

    return images;
  }

  public async componentDidMount() {
    const {
      match,
      history,
      location,
      services: { isUserLoggedIn, adminAPI, currentUserID, pro },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    const {
      params: { id: assetCollectionID },
    } = match;

    // const setInfoRes = await adminAPI.getSingleItemGeneral('asset_collections', assetCollectionID);

    const [
      setInfoRes,
      assetsRes,
      vimeoRes,
      videoRes,
      vimeoAssetRes,
    ] = await Promise.all([
      adminAPI.getSingleItemGeneral("asset_collections", assetCollectionID),
      adminAPI.getCollectionItems(assetCollectionID),
      adminAPI.getVimeoVideos(),
      adminAPI.getCollectionVideoItems(assetCollectionID),
      adminAPI.getCollectionVimeoItems(assetCollectionID),
    ]);

    if (setInfoRes.ok) {
      console.log("AssetsRes: " + JSON.stringify(assetsRes.data, null, 2));
      console.log("vimeoRes: " + JSON.stringify(vimeoRes.data, null, 2));
      console.log("videoRes: " + JSON.stringify(videoRes.data, null, 2));

      const assetCollection = setInfoRes.data;

      const assets = assetsRes.data.assets;

      const videoAssets = videoRes.data.assets;

      const vimeoAssets = vimeoAssetRes.data.assets;

      const vimeoVids = vimeoRes.data.videos;

      this.setState({
        data: {
          activetab: "1",
          assetCollection,
          assetCollectionID,
          assets,
          imagemodal: false,
          selectedImage: {},
          slideIndex: 0,
          uploadModal: false,
          vimeoModal: false,
          vimeoItems: vimeoVids,
          videoAssets,
          vimeoAssets,
        },
      });
    } else {
      toast.error("Error fetching course details!");
    }
  }

  public onSlide(currentIndex) {
    console.log(currentIndex);

    const data = this.state.data;

    data.slideIndex = currentIndex;

    this.setState({ data });
  }

  public handleChange(id, e) {
    console.log(e);
    const data = this.state.data;
    data.assetCollection[id] = e.target.value;
    this.setState({
      data,
    });
  }

  public handleImageChange(id, e) {
    console.log(e);
    const data = this.state.data;
    data.selectedImage[id] = e.target.value;
    this.setState({
      data,
    });
  }

  public showVimeoList(data) {
    return data.vimeoItems.map((d, i) => (
      // tslint:disable-next-line jsx-no-lambda
      <Col key={d.id} style={{ margin: 6 }}>
        <Vimeo
          video={`https://player.vimeo.com/video/${d.FileName}`}
          autoplay={false}
        />
      </Col>
    ));
  }

  public async updateInfo() {
    this.setState({
      loaded: false,
    });

    const item = this.state.data.assetCollection;

    const res = await this.props.services.adminAPI.updateItemGeneral(
      "asset_collections",
      item,
      item.AssetCollectionId
    );

    if (res.ok) {
      toast.success("Update Successful");
    } else {
      toast.error("Update Failed");
    }

    this.setState({
      loaded: true,
    });
  }

  public async imageUpdateInfo() {
    this.setState({
      loaded: false,
    });

    const curritem = this.state.data.selectedImage;
    console.log('ItemToChange: ' + JSON.stringify(curritem))
    const item = {
      Name: curritem.Title,
      Description: curritem.Description,
    };

    const res = await this.props.services.adminAPI.updateAssetPartial(
      item,
      curritem.id
    );

    if (res.ok) {
      toast.success("Update Successful");
      const data = this.state.data;
      data.imagemodal = !data.imagemodal;
      this.setState({ data });
    } else {
      toast.error("Update Failed");
    }

    this.setState({
      loaded: true,
    });
  }

  public imageClick(item) {
    console.log(item);
    const data = this.state.data;

    data.selectedImage = data.assets[data.slideIndex];

    data.imagemodal = !data.imagemodal;

    this.setState({ data });
  }

  public vimeoVideoClick(item) {
    console.log(item);
    const data = this.state.data;

    data.selectedImage = item;

    data.imagemodal = !data.imagemodal;

    this.setState({ data });
  }

  // onThumbnailClick={this.imageClick}

  public _renderCustomControls() {
    return (
      // tslint:disable-next-line jsx-no-bind
      <GalleryButton onClick={this.imageClick.bind(this)}>Edit</GalleryButton>
    );
  }

  public render() {
    const { data } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.isNavigate) {
      return <Redirect to={this.state.destination} />;
    }

    if (Object.keys(data).length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <Wrapper>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>
              &lt; Back
            </p>
          </ContentRow>
        </Content>
        <Content>
          <ContentRowSingleCol className="single-col">
            <Nav tabs={true} style={{ flexWrap: "nowrap" }}>
              <NavItem>
                <NavLink onClick={this.setTab.bind(this, "1")}>Images</NavLink>
              </NavItem>
              <NavItem>
                <NavLink onClick={this.setTab.bind(this, "3")}>Videos</NavLink>
              </NavItem>
              <NavItem>
                <NavLink onClick={this.setTab.bind(this, "4")}>Vimeo</NavLink>
              </NavItem>
              <NavItem>
                <NavLink onClick={this.setTab.bind(this, "2")}>Info</NavLink>
              </NavItem>
            </Nav>
          </ContentRowSingleCol>

          <ContentRowSingleCol>
            <Loader color="#acff24" loaded={this.state.loaded} />

            <Button style={{ marginLeft: "5px" }} onClick={this.uploadToggle}>
              New Asset
            </Button>

            <Button style={{ marginLeft: "5px" }} onClick={this.vimeoToggle}>
              New Vimeo
            </Button>

            <TabContent activeTab={data.activetab}>
              <TabPane tabId="1">
                <Content>
                  <ContentCol>
                    <ImageGallery
                      lazyLoad={true}
                      defaultImage={
                        "http://d29x94w0cyhvbe.cloudfront.net/assets/64bf7f5c68d1038c.jpg"
                      }
                      onSlide={this.onSlide}
                      thumbnailPosition={"top"}
                      items={this.processImages(data.assets)}
                      renderCustomControls={this._renderCustomControls}
                    />
                  </ContentCol>
                </Content>
              </TabPane>

              <TabPane tabId="2">
                <ContentRow>
                  <ContentCol>
                    <div>
                      <label htmlFor="title" style={{ display: "block" }}>
                        Title
                      </label>
                      {/*tslint:disable-next-line jsx-no-lambda*/}
                      <textarea
                        rows={6}
                        cols={38}
                        id="title"
                        value={data.assetCollection.Name}
                        onChange={this.handleChange.bind(this, "Name")}
                      />
                    </div>
                  </ContentCol>

                  <ContentCol>
                    <div>
                      <label htmlFor="description" style={{ display: "block" }}>
                        Description
                      </label>
                      {/*tslint:disable-next-line jsx-no-lambda*/}
                      <textarea
                        rows={6}
                        cols={38}
                        id="description"
                        value={data.assetCollection.Description}
                        onChange={this.handleChange.bind(this, "Description")}
                      />
                    </div>
                  </ContentCol>
                </ContentRow>

                <ContentRowSingleCol>
                  <div>
                    <Button onClick={this.updateInfo}>Update</Button>
                  </div>
                </ContentRowSingleCol>
              </TabPane>

              <TabPane tabId="4">
                <Content>
                  <Row>
                    {data.vimeoAssets.map((d, i) => (
                      // tslint:disable-next-line jsx-no-lambda
                      <Col
                        key={d.id}
                        style={{ margin: 6, height: "400px", color: "white" }}
                      >
                        <Vimeo
                          video={`https://player.vimeo.com/video/${d.FileName}`}
                          autoplay={false}
                          height="300px"
                          width="350px"
                        />
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button
                          onClick={this.vimeoVideoClick.bind(this, d)}
                          style={{ width: "350px" }}
                        >
                          Edit
                        </Button>
                      </Col>
                    ))}
                  </Row>
                </Content>
              </TabPane>

              <TabPane tabId="3">
                <Content>
                  <Row>
                    {data.videoAssets.map((d, i) => (
                      // tslint:disable-next-line jsx-no-lambda
                      <Col
                        key={d.id}
                        style={{ margin: 6, height: "400px", color: "white" }}
                      >
                        <Player
                          // style={{ height: "500" }}
                          playsInline={true}
                          src={PROXIED_MEDIABASE + "assets/" + d.FileName}
                          height={340}
                          width={360}
                        >
                          {/* <BigPlayButton position="center" /> */}
                        </Player>
                        <br />
                        <br />
                        {/*tslint:disable-next-line jsx-no-lambda*/}
                        <Button
                          onClick={this.vimeoVideoClick.bind(this, d)}
                          style={{ width: "350px" }}
                        >
                          Edit
                        </Button>
                      </Col>
                    ))}
                  </Row>
                </Content>
              </TabPane>
            </TabContent>

            {this.imageModal(data)}
          </ContentRowSingleCol>
        </Content>

        <Content>
          <Modal
            isOpen={data.uploadModal}
            toggle={this.uploadToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.uploadToggle}> Assets Upload</ModalHeader>
            <ModalBody>
              <form onSubmit={this.uploadSubmit}>
                <Row>
                  <Col xs="12">
                    <input
                      id="upld"
                      type="file"
                      name="upld"
                      accept=".mp3,.mp4,.png,.jpeg,.jpg"
                      multiple={true}
                      required={true}
                    />
                  </Col>
                  <br />
                  <br />

                  <Col xs="12">
                    <input
                      id="description"
                      type="description"
                      name="description"
                      placeholder="description"
                      required={true}
                    />
                  </Col>
                  <br />
                  <br />

                  <Loader color="#3EE9F7" loaded={!data.uploading}>
                    <Button
                      color="primary"
                      type="submit"
                      className="adminmodalbutton"
                    >
                      Submit
                    </Button>
                    <Button
                      onClick={this.uploadToggle}
                      className="adminmodalbutton"
                    >
                      Cancel
                    </Button>
                  </Loader>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Content>

        <Content>
          <Modal
            isOpen={data.vimeoModal}
            toggle={this.vimeoToggle}
            style={{ marginTop: "10%" }}
          >
            <ModalHeader toggle={this.vimeoToggle}> Vimeo List</ModalHeader>
            <ModalBody>
              <Scrollbars style={{ paddingTop: "2em", height: "38em" }}>
                <Row>
                  {data.vimeoItems.map((d, i) => (
                    // tslint:disable-next-line jsx-no-lambda
                    <Col
                      key={d.id}
                      style={{ margin: 6, height: "400px", color: "white" }}
                    >
                      <Vimeo
                        video={`https://player.vimeo.com/video/${d.VideoData.id}`}
                        autoplay={false}
                        height="300px"
                        width="350px"
                      />
                      {/*tslint:disable-next-line jsx-no-lambda*/}
                      <Button
                        onClick={this.saveVimeo.bind(this, d.id)}
                        style={{ width: "350px" }}
                      >
                        Save To Collection{" "}
                      </Button>
                    </Col>
                  ))}
                </Row>
              </Scrollbars>
            </ModalBody>
          </Modal>
        </Content>
      </Wrapper>
    );
  }
}

export default withServices(AssetCollection);



// WEBPACK FOOTER //
// ./src/pages/Admin/AssetCollections/AssetCollection/AssetCollection.tsx